module.exports = __webpack_public_path__ + "static/img/app_default_img.158d938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app_default_img.png
// module id = eb+c
// module chunks = 14